import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import SortableTree, { NodeData, FullTree, OnMovePreviousAndNextLocation } from 'react-sortable-tree';
import { AdminProductCategoryList } from '@api/graphql/types';
import Path from '@root/utils/Path';
import { DispatchProp, connect } from 'react-redux';
import { ApplicationState } from 'reducers/';
import { Drawer, Notification } from 'components/';
import GraphQLClient from '@api/graphql/GraphQLClient';
import {
    ProductCategory as ProductCategoryType,
    updateProductCategoryVariables,
} from '@api/graphql/types';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';

interface StateType {
    treeData: any;
}

type Props = {
    productCategories: Array<AdminProductCategoryList | null>,
} & InjectedIntlProps & RouteComponentProps & DispatchProp;


class ProductCategoryList extends React.Component<Props, StateType> {
    public state = {
        treeData: [],
    };

    public componentDidMount() {
        const treeData = Object.keys(this.props.productCategories).map(key => this.props.productCategories[key]);
        this.setState({treeData});
    }

    private onMove = async (data: NodeData & FullTree & OnMovePreviousAndNextLocation) => {
        const position = {
            after: undefined,
            before: undefined,
        };

        const siblings = (data.nextParentNode && data.nextParentNode.children) ?
            data.nextParentNode.children :
            data.treeData;
        const index = siblings.indexOf(data.node);
        if (index === 0) {
            position.before = siblings[1].id;
        } else {
            position.after = siblings[(index - 1)].id;
        }

        GraphQLClient.query<ProductCategoryType>({
            query: Queries.productCategory,
            variables: {id: data.node.id},
        }).then((response) => {
            if (response.data && response.data.adminProductCategoryById) {
                const result = response.data.adminProductCategoryById;
                const variables: updateProductCategoryVariables = {
                    id: result.id,
                    name: result.name,
                    parent_id: result.parent_id,
                    url_key: result.url_key,
                    content: result.content,
                    is_enable: result.is_enable,
                    date_from: result.date_from,
                    date_to: result.date_to,
                    show_in_menu: !!result.show_in_menu,
                    keywords: result.keywords,
                    description: result.description,
                    is_promotion: result.is_promotion,
                    is_homepage_prohibited: result.is_homepage_prohibited,
                    ...position,
                };
                GraphQLClient.mutate({
                    mutation: Mutations.updateProductCategory,
                    variables,
                }).then(() => {
                    Notification.success(this.props.intl.formatMessage({ id: 'notification.succeed' }));
                });
            }
        }).catch((e: any) => {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    public render() {
        const addButton = <button className="btn btn-primary" onClick={(e: React.SyntheticEvent) => this.props.history.push(Path.productCategoryCreate)}>{this.props.intl.formatMessage({id: 'module.productCategory.create.title'})}</button>;

        return (
            <Drawer headerButton={addButton}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content scrollable">
                                <SortableTree
                                    treeData={this.state.treeData}
                                    onChange={treeData => {
                                        this.setState({ treeData });
                                    }}
                                    generateNodeProps={({ node, path }) => ({
                                        title: <span>{node.name}</span>,
                                        buttons: [<button className="btn btn-primary btn-sm" style={{margin: '5px'}} key={node.id} onClick={() => this.props.history.push(`${Path.productCategory}/${node.id}`)}>Szerkesztés</button>],
                                    })}
                                    onMoveNode={this.onMove}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    return {productCategories: state.productCategories};
};

export default compose(
    withRouter,
    injectIntl,
    connect(mapStateToProps),
)(ProductCategoryList);



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/pages/ProductCategoryList.tsx